
/* Sin uso, se encontró el estilo correcto :D */
export default function isInternetExplorer11 () {
  if (navigator.appName === 'Microsoft Internet Explorer') {
    // console.warn('is ie: MIE');
    // window.location.assign('http://protisa.strategio.cloud/at/mMetro/index.php')
    return -1
  } else if ((navigator.appName === 'Netscape') && (navigator.appVersion.indexOf('Trident') !== -1)) {
    // console.warn('is ie: netscape');
    // window.location.assign('http://protisa.strategio.cloud/at/mMetro/index.php')
    return 1
  } else {
    // console.log("wat ta faq");
    // window.location.assign('http://protisa.strategio.cloud/new/index.html')
    return 0
  }
}



// WEBPACK FOOTER //
// ./src/utils/navigator.js